import React from "react";
import { Field, ErrorMessage } from "formik";
import { Label, FormGroup } from "reactstrap";

const FormikInput = React.forwardRef(
  (
    { name, type, label, hideLabel, hideValidation, errors, touched, ...props },
    ref
  ) => (
    <FormGroup>
      {!hideLabel && <Label for={name}>{label}</Label>}
      <Field
        type={type}
        name={name}
        innerRef={ref}
        valid={!hideValidation && !errors[name] && touched[name]}
        invalid={!hideValidation && errors[name] && touched[name]}
        {...props}
      />
      {!hideValidation && (
        <ErrorMessage
          className="font-weight-bold"
          name={name}
          component="div"
        />
      )}
    </FormGroup>
  )
);

export default FormikInput;
